export default [
  'subscription-form',
  'subscription-page',
  'subscription-success',
  'plans',
  'metrics-dashboard',
  'dashboard',
  'login',
] as const;
